module.exports = __webpack_public_path__ + "static/hide-e38ed7942a951fc04611539e18eedada.png";